import { render, staticRenderFns } from "./KidjoFeatureSection.vue?vue&type=template&id=39defedc&scoped=true"
import script from "./KidjoFeatureSection.vue?vue&type=script&lang=js"
export * from "./KidjoFeatureSection.vue?vue&type=script&lang=js"
import style0 from "./KidjoFeatureSection.vue?vue&type=style&index=0&id=39defedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39defedc",
  null
  
)

export default component.exports